/* TC-234 / TC-414 / TC-427 "Today's Offer" coupon chip.
   TC-427: the offer is revealed in place — no sheet, no pop-up, no network call.
   snippets/coupon-sleek.liquid renders ONE chip per PDP with the template's
   chosen code (B3G1FREE first, else offer_1) already in the markup; this script
   only wires the Copy button: clipboard write (with a textarea fallback) and a
   "Copied ✓" flash. It never throws a visible error; the page keeps working
   regardless. Hooks: [data-tc234] root, [data-tc234-trigger] = the Copy button
   (data-code), data-tc234-offers = JSON of the rendered offer (for tests). */
(function () {
  'use strict';

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        return fallbackCopy(text);
      });
    }
    return fallbackCopy(text);
  }

  function fallbackCopy(text) {
    return new Promise(function (resolve, reject) {
      try {
        var el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'fixed';
        el.style.top = '-1000px';
        el.style.opacity = '0';
        document.body.appendChild(el);
        el.focus();
        el.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(el);
        ok ? resolve() : reject(new Error('execCommand failed'));
      } catch (e) {
        reject(e);
      }
    });
  }

  function flash(btn) {
    var original = btn.getAttribute('data-original') || 'Copy';
    btn.setAttribute('data-original', original);
    btn.textContent = 'Copied ✓';
    btn.classList.add('is-copied');
    window.clearTimeout(btn.__t);
    btn.__t = window.setTimeout(function () {
      btn.textContent = original;
      btn.classList.remove('is-copied');
    }, 2200);
  }

  function initChip(root) {
    if (root.__tc234Init) return;
    root.__tc234Init = true;
    var btn = root.querySelector('.tc234-copy');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var code = btn.getAttribute('data-code') || '';
      if (!code) return;
      copyText(code).then(
        function () { flash(btn); },
        function () { flash(btn); } // text is selectable anyway; still confirm
      );
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-tc234]');
    for (var i = 0; i < roots.length; i++) initChip(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
